import * as apiService from "./v2/apiService";
import { baseURL } from "@/constants/v2/endPoints";

const RESULTS_URL = `${baseURL}api/v2/results`;

const dataOf = (response) => response?.data || null;

export const getNetworkResults = async (days) =>
  dataOf(await apiService.apiCall(`${RESULTS_URL}/network?days=${encodeURIComponent(days)}`, "GET", {}));

export const getGitchaResults = async (days) =>
  dataOf(await apiService.apiCall(`${RESULTS_URL}/gitcha?days=${encodeURIComponent(days)}`, "GET", {}));

export const getWins = async () => dataOf(await apiService.apiCall(`${RESULTS_URL}/wins`, "GET", {}));

export const updateWin = async (id, action) =>
  dataOf(await apiService.apiCall(`${RESULTS_URL}/wins/${encodeURIComponent(id)}`, "PATCH", { action }));

export const addContactToClients = async (contactId) =>
  dataOf(await apiService.apiCall(`${RESULTS_URL}/contacts/${encodeURIComponent(contactId)}/client`, "POST", {}));
